export function flattenObject(
  obj: any,
  prefix: string = "$json",
  fields: Array<{ path: string; value: any }> = [],
): Array<{ path: string; value: any }> {
  if (obj === null || obj === undefined) {
    return fields;
  }

  // Add the current level
  fields.push({ path: prefix, value: obj });

  // If it's an object (not array), recursively add nested fields
  if (typeof obj === "object" && !Array.isArray(obj)) {
    Object.entries(obj).forEach(([key, value]) => {
      const newPath = `${prefix}.${key}`;
      flattenObject(value, newPath, fields);
    });
  }

  // If it's an array, add array notation for first item as example
  if (Array.isArray(obj) && obj.length > 0) {
    flattenObject(obj[0], `${prefix}[0]`, fields);
  }

  return fields;
}
